// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4009) return "static/chunks/4009-0ca4866a85e4be07.js";
	if (chunkId === 7776) return "static/chunks/477d4af2-fb9519a62458603a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2930":"5800c5bc1ad60de5","6321":"8ca4b7d7d29cd1a1"}[chunkId] + ".js";
};